/* eslint-disable no-undef, react/prop-types */
import React from 'react';
import { css, keyframes } from 'react-emotion';
import Img from 'gatsby-image';
import Link from 'gatsby-link';
import { Box } from '../components/Layout';
import colors from '../utils/colors';
import palloSiluetti from '../assets/images/pallo_siluetti.svg';

const slidein = keyframes`
	0% {
		top: 100%;
  }
  50% {
    top: 40%;
  }
  100% {
    top: -200%;
  }
`;

const sway = keyframes`
	0%, 20%, 40% {
		transform: rotate(5deg);
  }
  10%, 30% {
    transform: rotate(-5deg);
  }
  50% {
    transform: rotate(-2deg);
  }
  60%, 80%, 100% {
		transform: rotate(2deg);
  }
  70%, 90% {
    transform: rotate(-2deg);
  }
`;

const fadein = keyframes`
  0% { opacity 0;}
  75% { opacity 0;}
  100% { opacity 1;}
`;

const mainStyle = css`
  opacity: 1;
  animation: ${fadein} 10s ease-in 1;
  text-align: center;
  p {
    width: 50%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 1em;
    margin-top: 1em;
  }
`;

const palloStyleBG = css`
  :after {
    content: ' ';
    opacity: 0.8;
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    background: url(${palloSiluetti}) no-repeat center;
    animation: ${slidein} 10s ease-in-out forwards,
      ${sway} 10s ease-in-out forwards;
    transform-origin: center 10%;
  }
`;

const imgStyle = css`
  max-height: 70vh;
  margin-left: 10%;
  margin-right: 10%;
`;
const outerImgWrapper = css`
  margin-left: auto;
  margin-right: auto;
  margin-top: 5.5rem;
`;

const container = css`
  margin-left: 10%;
  margin-right: 10%;
  margin-top: 8rem;
  .ytWrapper {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    .video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
}
`;

const content = ({ data }) => {
  const { juliste } = data;
  return (
    <div className={palloStyleBG}>
      <Box className={mainStyle}>
        <Box
          width={[1, 1, 1 / 2]}
          m={['0 0 0 0', '0 0 0 0', '0 auto 0 auto']}
          px={[3, 3, 0]}
          color={colors.primary}
          align="center"
        />
        <div className={container}>
          <div className="ytWrapper">
            <iframe className="video" src="https://www.youtube.com/embed/gELEUdaIXLY" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
          </div>
        </div>
        <Link to="/teoksesta">
          <Img
            className={imgStyle}
            outerWrapperClassName={outerImgWrapper}
            alt="Graafikko: Jussi-Pekka Koivisto"
            sizes={juliste.childImageSharp.sizes}
            imgStyle={{ objectFit: 'contain', objectPosition: 'top center' }}
          />
        </Link>
        <p>
          Ystävykset Tytti, Maija ja Franz tempautuvat elämänsä seikkailuun
          yrittäessään pelastaa Owlan ahneen Apteekkarin kynsistä. Owlan valkea
          kaupunki kutsuu koko perheen mukaan suureen seikkailuun!
        </p>
      </Box>
    </div>
  );
};

export const query = graphql`
  query contentQuery {
    juliste: file(relativePath: { eq: "owla_juliste_some_v3.jpg" }) {
      childImageSharp {
        sizes(maxWidth: 700) {
          ...GatsbyImageSharpSizes_noBase64
        }
      }
    }
  }
`;

export default content;



// WEBPACK FOOTER //
// ./src/pages/index.js